module.exports = __webpack_public_path__ + "static/media/productTypePA.f9fc2e4e.svg";